'use client';

import { cn } from '@insta-club/utilities';
import Image from 'next/image';
import { useState } from 'react';

interface AvatarProps {
    src?: string;
    alt: string;
    size?: number;
    className?: string;
}

export default function Avatar({ src, alt, size = 40, className = '' }: AvatarProps) {
    const [error, setError] = useState(false);

    return (
        <div
            className={cn(
                'bg-primary-50 flex shrink-0 items-center justify-center overflow-hidden rounded-full',
                className
            )}
            style={{
                width: size,
                height: size,
                lineHeight: 0 /* ✳️ مهم: حذف baseline */
            }}
        >
            {!error && src ? (
                <Image
                    src={src}
                    alt={alt}
                    width={size}
                    height={size}
                    onError={() => setError(true)}
                    className='pointer-events-none block h-full w-full object-cover select-none'
                    draggable={false}
                    quality={75}
                    priority
                />
            ) : (
                <span
                    className='text-primary-500 !font-sans text-sm leading-none font-bold'
                    style={{ transform: 'translateY(1px)' }}
                >
                    {alt.charAt(0).toUpperCase()}
                </span>
            )}
        </div>
    );
}

